import React, { useMemo } from 'react';
import cn from 'classnames';
import ErrorBoundary from '../ErrorBoundary';
import localization from '../../shared/strings';
import { ThemeConsumer } from '../../contexts/themeContext';
import { navigate } from '../../helpers/history';
import Tooltip from '../Tooltip';
import ua from '../../ua';
import './styles.scss';

const tooltipTrigger = (ua.isMobileApp() && ua.isAppleDevice()) ? null : 'hover';

/**
 * Tag
 * @param {Object} props
 * @param {string?} props.text
 * @param {string?} props.className
 * @param {Function?} props.onClick
 * @param {string?} props.tooltip
 * @returns {JSX}
 */
const Tag = (props) => {
  const {
    text = localization.UPGRADE_PLAN.text,
    className,
    onClick = () => navigate('/billing?tab=overview'),
    tooltip = localization.UPGRADE_PLAN.tooltip,
    withWrapper = false,
    isUpgradePlan = true,
  } = props;

  const textForUpgrade = useMemo(() => {
    if (ua.isMobileApp() && ua.isAppleDevice()) {
      return localization.UPGRADE_PLAN.textForMobileApps;
    } return text;
  }, [text]);

  const handleOnClick = useMemo(() => {
    if (!isUpgradePlan) return;
    if (ua.isMobileApp() && ua.isAppleDevice()) {
      return null;
    } return onClick;
  }, [onClick]);

  return (
    <ErrorBoundary>
      <ThemeConsumer>
        {({ themes }) => (
          <Choose>
            <When condition={withWrapper}>
              <div className="upgradePlan__wrapper">
                <Tooltip content={tooltip} placement="top" trigger={tooltipTrigger}>
                  <div
                    className={cn('upgradePlan', { [className]: Boolean(className) })}
                    style={{ backgroundColor: isUpgradePlan ? themes.upgradePlanBg : themes.legacyBg }}
                    onClick={handleOnClick}
                  >
                    <If condition={textForUpgrade}>
                      <span className="upgradePlanText">{textForUpgrade}</span>
                    </If>
                  </div>
                </Tooltip>
              </div>
            </When>
            <Otherwise>
              <Tooltip content={tooltip} placement="top" trigger={tooltipTrigger}>
                <div
                  className={cn('upgradePlan', { [className]: Boolean(className) })}
                  style={{ backgroundColor: isUpgradePlan ? themes.upgradePlanBg : themes.legacyBg }}
                  onClick={handleOnClick}
                >
                  <If condition={textForUpgrade}>
                    <span className="upgradePlanText">{textForUpgrade}</span>
                  </If>
                </div>
              </Tooltip>
            </Otherwise>
          </Choose>
        )}
      </ThemeConsumer>
    </ErrorBoundary>

  );
};

export default Tag;
